export default __webpack_public_path__ + "static/assets/40da269fec27e12b6069a0a0f19923f9.png";